export { type PresentationDeleteRequest } from './PresentationDeleteRequest';
export { type PresentationDownloadRequest } from './PresentationDownloadRequest';
export { type PresentationExportRequest } from './PresentationExportRequest';
export { type PresentationHistoryRequest } from './PresentationHistoryRequest';
export { type PresentationImportRequest } from './PresentationImportRequest';
export { type PresentationIssueRequest } from './PresentationIssueRequest';
export { type PresentationLatestRequest } from './PresentationLatestRequest';
export { type PresentationRestoreRequest } from './PresentationRestoreRequest';
export { type PresentationRevisionRequest } from './PresentationRevisionRequest';
export { type PresentationSearchRequest } from './PresentationSearchRequest';
export { type PresentationUpdateAnnotationsRequest } from './PresentationUpdateAnnotationsRequest';
export { type PresentationUpdateLabelsRequest } from './PresentationUpdateLabelsRequest';
export { type PresentationUploadRequest } from './PresentationUploadRequest';
export { type PresentationVerifyRequest } from './PresentationVerifyRequest';
